import cn from 'classnames'
import { Dispatch, Fragment, SetStateAction, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'

import { HintComponent } from '../../../HintComponent'
import { GLOBAL_TOTAL_CATEGORY, OVERALL_CATEGORY } from '../../config'
import { IGlobalCategory } from '../../models/IGlobalCategory'
import { GlobalCategoryOption } from '../globalCategoryOption/GlobalCategoryOption'

import styles from './GlobalCategorySwitcher.module.scss'

export interface IProps {
  globalCategories: IGlobalCategory[]
  globalCategory: IGlobalCategory | undefined
  setGlobalCategory: Dispatch<SetStateAction<IGlobalCategory | undefined>>
  className?: string
  isVisible?: boolean
  isQualityViewSelected?: boolean
  onQualityViewChange?: (value: boolean) => void
}

export const GlobalCategorySwitcher = ({
  globalCategories,
  globalCategory,
  setGlobalCategory,
  className,
  isVisible = true,
  isQualityViewSelected = false,
  onQualityViewChange,
}: IProps) => {
  const isShowButtons = useMemo(
    () => isVisible && !!globalCategories,
    [globalCategories, isVisible]
  )

  const parentCategories = useMemo(() => {
    const categories = globalCategories.filter(
      (el) =>
        !el.GlobalSubCategory ||
        el.GlobalSubCategory === OVERALL_CATEGORY ||
        el.GlobalSubCategory === GLOBAL_TOTAL_CATEGORY
    )

    const groupIndex = categories.findIndex((el) => !el.IsMainHierarchy)
    if (groupIndex > 0) {
      categories.splice(groupIndex, 1, { ...categories[groupIndex], IsStartGroup: true })
    }

    return categories
  }, [globalCategories])

  return (
    <div className={className || styles.root}>
      {!!onQualityViewChange && (
        <Button
          className={styles.qualityButton}
          color={isQualityViewSelected ? 'primary' : 'grey'}
          margin={'md'}
          onClick={() => onQualityViewChange(!isQualityViewSelected)}
        >
          <Translation text="jbp-planning-quality-switcher" span />
        </Button>
      )}
      {isShowButtons && (
        <>
          {parentCategories.map((el, idx) => {
            return (
              <Fragment key={`jbp-planning-global-switcher-${idx}`}>
                {!!el.IsStartGroup && (
                  <div className={cn({ [styles.separator]: el.IsStartGroup })}>
                    <HintComponent
                      text={`jbp-planning-global-switcher-main-hierarchy-separator`}
                      className={styles.hint}
                      iconWrapStyle={styles.hint__icon}
                    />
                  </div>
                )}
                <GlobalCategoryOption
                  key={`jbp-planning-global-switcher-${idx}-option`}
                  allCategories={globalCategories}
                  category={el}
                  categoryIndex={idx}
                  currentCategory={isQualityViewSelected ? undefined : globalCategory}
                  onSelectCategory={(selectedCategory: IGlobalCategory) => {
                    onQualityViewChange && onQualityViewChange(false)
                    if (setGlobalCategory) {
                      setGlobalCategory(selectedCategory)
                    }
                  }}
                />
              </Fragment>
            )
          })}
        </>
      )}
    </div>
  )
}
